import {
  Home, Target, UserCircle2, Users, Building2, IdCard, Clock, CalendarOff, ListChecks, CalendarDays,
  LifeBuoy, FolderOpen, BarChart3, Sparkles, Settings, FileSignature, CheckSquare,
} from "lucide-react";

const ALL = ["business_owner", "business_admin", "manager", "employee", "sales_user"];
const ADMIN = ["business_owner", "business_admin"];

export const NAV = [
  { key: "home", label: "Home", path: "/crm-app", icon: Home, roles: ALL },
  { key: "sales", label: "CRM & Sales", path: "/crm-app/sales", icon: Target, roles: ALL },
  { key: "my-space", label: "My Space", path: "/crm-app/my-space", icon: UserCircle2, roles: ALL },
  { key: "team", label: "Team", path: "/crm-app/team", icon: Users, roles: ALL },
  { key: "organization", label: "Organization", path: "/crm-app/organization", icon: Building2, roles: ALL },
  { key: "employees", label: "Employees", path: "/crm-app/employees", icon: IdCard, roles: [...ADMIN, "manager"] },
  { key: "attendance", label: "Attendance", path: "/crm-app/attendance", icon: Clock, roles: ALL, phase2: true },
  { key: "leave", label: "Leave", path: "/crm-app/leave", icon: CalendarOff, roles: ALL, phase2: true },
  { key: "tasks", label: "Tasks", path: "/crm-app/tasks", icon: ListChecks, roles: ALL },
  { key: "calendar", label: "Calendar", path: "/crm-app/calendar", icon: CalendarDays, roles: ALL },
  { key: "helpdesk", label: "HR Help Desk", path: "/crm-app/helpdesk", icon: LifeBuoy, roles: ALL, phase2: true },
  { key: "documents", label: "Documents", path: "/crm-app/documents", icon: FolderOpen, roles: ALL, phase2: true },
  { key: "reports", label: "Reports", path: "/crm-app/reports", icon: BarChart3, roles: ALL },
  { key: "ai", label: "AI Assistant", path: "/crm-app/ai", icon: Sparkles, roles: ALL },
  { key: "settings", label: "Settings", path: "/crm-app/settings", icon: Settings, roles: ALL },
];

export const EXTRA_PHASE2 = {
  approvals: { label: "Approvals", icon: CheckSquare },
  "hr-letters": { label: "HR Letters", icon: FileSignature },
};

export const PHASE2_INFO = {
  attendance: "Clock-in/out, shift schedules and attendance regularisation.",
  leave: "Leave balances, requests and manager approvals.",
  helpdesk: "Raise HR queries and track responses from your HR team.",
  documents: "Company and employee documents with secure storage.",
  approvals: "A single inbox for leave, attendance and expense approvals.",
  "hr-letters": "Generate offer, experience and employment letters from templates.",
};

export const LAUNCHER = [
  { group: "Sales", items: [
    { label: "Pipeline", path: "/crm-app/sales/pipeline", icon: Target },
    { label: "Contacts", path: "/crm-app/sales/contacts", icon: Users },
    { label: "Companies", path: "/crm-app/sales/companies", icon: Building2 },
    { label: "Leads", path: "/crm-app/sales/leads", icon: Target },
    { label: "AI Assistant", path: "/crm-app/ai", icon: Sparkles },
  ] },
  { group: "People & HR", items: [
    { label: "Team", path: "/crm-app/team", icon: Users },
    { label: "Employees", path: "/crm-app/employees", icon: IdCard, roles: [...ADMIN, "manager"] },
    { label: "Attendance", path: "/crm-app/attendance", icon: Clock, phase2: true },
    { label: "Leave", path: "/crm-app/leave", icon: CalendarOff, phase2: true },
    { label: "Approvals", path: "/crm-app/approvals", icon: CheckSquare, phase2: true },
    { label: "HR Help Desk", path: "/crm-app/helpdesk", icon: LifeBuoy, phase2: true },
    { label: "HR Letters", path: "/crm-app/hr-letters", icon: FileSignature, phase2: true },
  ] },
  { group: "Productivity", items: [
    { label: "Tasks", path: "/crm-app/tasks", icon: ListChecks },
    { label: "Calendar", path: "/crm-app/calendar", icon: CalendarDays },
    { label: "My Space", path: "/crm-app/my-space", icon: UserCircle2 },
  ] },
  { group: "Documents", items: [
    { label: "Documents", path: "/crm-app/documents", icon: FolderOpen, phase2: true },
    { label: "Policies", path: "/crm-app/organization/policies", icon: FileSignature },
  ] },
  { group: "Reports", items: [
    { label: "My Reports", path: "/crm-app/reports/my", icon: BarChart3 },
    { label: "Team Reports", path: "/crm-app/reports/team", icon: BarChart3, roles: [...ADMIN, "manager"] },
  ] },
  { group: "Administration", items: [
    { label: "Organization", path: "/crm-app/organization", icon: Building2 },
    { label: "Settings", path: "/crm-app/settings", icon: Settings },
  ] },
];
